import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Competence, Course, V3CourseTeacherProfile, V3TeacherProfile} from "../../model/v3/schools";

@Component({
    selector: 'app-manager-casa-teacher-profile',
    templateUrl: './manager-casa-teacher-profile.component.html',
    styleUrls: ['./manager-casa-teacher-profile.component.scss'],
    standalone: false
})
export class ManagerCasaTeacherProfileComponent implements OnInit {

  courses = [Course.en, Course.enBs, Course.enKid, Course.es];
  courseNames = ["English", "Business English", "English for kids", "Spanish"];
  competences = [Competence.A,
    Competence.B, Competence.C, Competence.D, Competence.PROVA, Competence.TEST]

  activeIdx = 0;
  @Input()
  busy = true;

  @Input() profile: V3TeacherProfile
  @Input() courseProfiles: V3CourseTeacherProfile[] = []

  @Output()
  saveProfile = new EventEmitter<V3TeacherProfile>();
  @Output()
  saveCourseProfile = new EventEmitter<V3CourseTeacherProfile>();
  @Output()
  deleteCourseProfile = new EventEmitter<V3CourseTeacherProfile>();

  constructor() { }

  ngOnInit(): void {
  }

  activate(i: number) {
    this.activeIdx = i;
  }

  hasCourse(course: Course) {
    return !!this.getCourse(course);
  }

  getCourse(course: Course) {
    if (!this.courseProfiles) return null;
    return this.courseProfiles.find(cd => cd.course.code === course.code)
  }

  activateLang(course: Course) {
    if (this.hasCourse(course)) return;
    const newCourse = {} as V3CourseTeacherProfile;
    newCourse.course = course;
    newCourse.competences = [];
    if(this.courseProfiles == null) this.courseProfiles = [];
    this.courseProfiles.push(newCourse);
  }

  hasCompetence(course: Course, competence: Competence) {
    const courseContext = this.getCourse(course);
    if (!courseContext) return false;
    return !!courseContext.competences.find(c => c.code == competence.code);
  }

  changeCompetence(course: Course, competence: Competence) {
    const courseContext = this.getCourse(course);
    if (!courseContext) return;
    const competenceFound = courseContext.competences.indexOf(competence);
    if (competenceFound >= 0) {
      courseContext.competences.splice(competenceFound, 1)
    } else {
      courseContext.competences.push(competence);
    }
  }

  removeCourse(course: Course) {
    const courseContext = this.getCourse(course);
    if (!courseContext) return;
    this.deleteCourseProfile.emit(courseContext)
  }

  onSave() {
    if (this.profile) {
      this.saveProfile.emit(this.profile);
    }
    let activeCourse = this.courses[this.activeIdx]
    this.courseProfiles
      .filter(cp => cp.course.code == activeCourse.code)
      .map(cp => this.saveCourseProfile.emit(cp))
  }
}
